// utils/objectUtils.ts
export const deepCompareObjects = (obj1: any, obj2: any): boolean => {
  // Check if they're exactly the same object
  if (obj1 === obj2) return true;

  // Check if either is null/undefined or not an object type
  if (
    typeof obj1 !== "object" ||
    typeof obj2 !== "object" ||
    obj1 === null ||
    obj2 === null
  ) {
    return false;
  }

  // Check if they have the same constructor
  if (obj1.constructor !== obj2.constructor) return false;

  // Handle special case for arrays
  if (Array.isArray(obj1)) {
    if (obj1.length !== obj2.length) return false;
    for (let i = 0; i < obj1.length; i++) {
      if (!deepCompareObjects(obj1[i], obj2[i])) return false;
    }
    return true;
  }

  // Get all keys of the objects
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Check if number of keys is the same
  if (keys1.length !== keys2.length) return false;

  // Check all keys recursively
  for (const key of keys1) {
    if (!keys2.includes(key)) return false;
    if (!deepCompareObjects(obj1[key], obj2[key])) return false;
  }

  return true;
};
